
class RoNewsletter extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.subscribe_btn');
    this.form = this.querySelector('form');
    this.email = this.querySelector('input[name="email"]');
    this.input = this.querySelectorAll('.error-message');
    this.birth = this.querySelector('input[name="dob"]');
    this.first_name = this.querySelector('input[name="first_name"]');
    this.last_name = this.querySelector('input[name="last_name"]');
    this.country = this.querySelector('select[name="country"]');
    this.error_notification = this.querySelector(".notification-error");
    this.list_id = this.dataset.id;
    this.check_error = this.dataset.check_error;
    this.error_msg = this.dataset.error;
    this.success_msg = this.dataset.success;
    this.addEvents();
  }

  addEvents() {
    let self = this;
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.buildData();
    });
  }


  async buildData() {
    let self = this;
    const url = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
    const method = "POST";

    const data = {
      "g": this.list_id,
      "email": this.email.value,
      "$fields": "$birth,$first_name,$last_name,$country",
      "$birth": this.birth.value,
      "$first_name": this.first_name.value,
      "$last_name": this.last_name.value,
      "$country": this.country.value,
    };

    const options = {
      method,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams(data),
    };

    try {
      const response = await fetch(url, options);
      const responseData = await response.json();

      if (responseData.success) {
        self.button.innerText = this.success_msg;
        self.button.classList.add('success');
      } else {
        console.error("Error while subscribing", responseData.errors);
        self.error_notification.innerText = this.error_msg;
      }
    } catch (error) {
      console.error("Exception while subscribing", error);
      self.error_notification.innerText = this.error_msg;
    }
  }
}

customElements.define("ro-newsletter", RoNewsletter);
